import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  projectedAgeFooter: {
    textAlign: "center",
    marginBottom: spacing.xs,
  },
};
